/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Ctatext1Inputs */

const zh_about_ctatext1 = /** @type {(inputs: About_Ctatext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始体验`)
};

const en_about_ctatext1 = /** @type {(inputs: About_Ctatext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const es_about_ctatext1 = /** @type {(inputs: About_Ctatext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {About_Ctatext1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_ctatext1 = /** @type {((inputs?: About_Ctatext1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Ctatext1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_ctatext1(inputs)
	if (locale === "en") return en_about_ctatext1(inputs)
	return es_about_ctatext1(inputs)
});
export { about_ctatext1 as "about_ctaText" }